<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="上传附件" :showFooter="true">
    <div class="uploadFile-upload">
      <ShareHeader />
      <div class="m-l-40 m-r-40 p-b-50 border">
        <div class="title m-b-40 m-t-60">上传附件</div>
        <div class="flex m-b-20">
          <img class="labelImage m-r-10" src="@/assets/news-upload-file-label.png" />
          <span>{{info.title}}</span>
        </div>
        <div class="font">
          <span>客户：</span>
          <span>{{info.customers}}</span>
        </div>
      </div>
      <div class="m-l-40 m-r-40">
        <div class="font m-t-40">请上传附件</div>
        <div class="font-sm gray-font m-b-40">可上传 pdf、jpg、png、jpeg格式的图片，每张图片不大于5M</div>
        <Upload :files="files" @onCaptured="onCaptured" />
      </div>
      <div class="m-t-100"></div>
      <div class="m-t-100"></div>
      <ion-button class="m-l-70 m-r-70" expand="block" @click="submit">提交</ion-button>
    </div>
  </BaseLayout>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { fileApi, infoApi } from '@/apis'
import { useRoute } from 'vue-router'
import router from '@/router'
import { toast } from '@/utils/alert'

export default {
  setup(props, { emit }) {
    const route = new useRoute()
    const files = ref([])
    const info = ref({})
    console.log('route', route.query)

    const onCaptured = (data) => {
      console.log('__data__', data)
      files.value = [...files.value, data]
      console.log('files.value', files.value)
    }

    const getData = async () => {
      const data = await infoApi.title({
        processNodeTblId: route.query.processNodeTblId,
        tblId: route.query.tblId,
        getCustomer: 1,
      })
      info.value = data
    }

    const submit = async () => {
      const fileIdArray = files.value.map((item) => item.id)
      await fileApi.appendixUpload({
        processNodeTblId: route.query.processNodeTblId,
        tblId: route.query.tblId,
        fileIdArray,
      })
      toast('提交')

      router.replace({
        path: '/nativeTab/news',
      })
    }

    onMounted(() => {
      getData()
    })

    return { files, info, submit, onCaptured }
  },
  components: {},
}
</script>
<style lang="scss">
.uploadFile-upload {
  display: flex;
  flex-direction: column;
  .title {
    font-size: 48px;
  }
  .labelImage {
    width: 144px;
    width: 72px;
  }
}
</style>